export default __webpack_public_path__ + "static/media/cars-mater.9b9aac38.png";